import { loadingAsyncState } from "widgets-for-react";
export const initialManagementState = (api)=>({
        reactions: loadingAsyncState(api.fetchUnknownReactions),
        submitting: false,
        validationMessages: []
    });
